import { Button, Col, Container, Image, ListGroup, ListGroupItem, Row } from "react-bootstrap";

import { Link } from "react-router-dom";
import React from "react";
import classes from './HomeContent.module.css';

function AboutContent() {
  return (
		<div class="container">
			<div class="row mt-5">

			<div className="col-3">
				<span className="fs-4"><h1>Nav</h1></span>
				<hr></hr>
				<ListGroup as="ul" className="nav nav-pills flex-column mb-auto">
					<ListGroup.Item className="nav-item border-0">
						<Link to="collection/london" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">collection 1</Link>
					</ListGroup.Item>
					<ListGroup.Item className="nav-item border-0">
						<Link to="collection/test" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">collection 2</Link>
					</ListGroup.Item>
					<ListGroup.Item className="nav-item border-0">
						<Link to="collection/test_pp_2" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">collection 3</Link>
					</ListGroup.Item>
				</ListGroup>
				<hr></hr>
				<ListGroup as="ul" className="nav nav-pills flex-column mb-auto mt-3">
					<ListGroup.Item className="nav-item border-0">
						<Link to="/archive" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">archive</Link>
					</ListGroup.Item>
        </ListGroup>
        <hr></hr>
        <ListGroup as="ul" className="nav nav-pills flex-column mb-auto mt-3">
					<ListGroup.Item className="nav-item border-0">
						<Link to="/about" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">about</Link>
					</ListGroup.Item>
					<ListGroup.Item className="nav-item border-0">
						<Link to="/portfolio" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">blog?</Link>
					</ListGroup.Item>
				</ListGroup>
			</div>		
			<div class="col-auto mt-5">
				<img id="mainImage" style={{ height: '550px'}} src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753753695/Lawan-blog/collections/IMG_6225_csw4hh.jpg"></img>
				filler
			</div>

			</div>
		</div>
  );
}

export default AboutContent;